import React from 'react';

import {
  ScreenAllFilters,
  ScreenFilters,
  ScreenFiltersApply,
} from 'components/Filters';

import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import AllFilters from './components/Filters/AllFilters';
import PrimaryFilters from './components/Filters/PrimaryFilters';
import IntegrationDataTable from './components/IntegrationDataTable';
import { IntegrationDetailsRouteElement } from './components/IntegrationDetails';
import {
  integrationsLink,
  integrationsSearchParams,
  integrationDetailsLink,
} from './navigation';
import { EMPTY_FILTERS } from './schemas';
import screenReducer from './screenReducer';

const id = 1074;
const permission = 85;

const Integrations = withScreen({
  name: 'integrations',
  searchParams: integrationsSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <ScreenFiltersApply />
        </ScreenFilters>
        <IntegrationDataTable />
        <Sentry.Routes>
          <Route
            path={integrationDetailsLink.path}
            element={<IntegrationDetailsRouteElement />}
          />
        </Sentry.Routes>
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  id: id,
  permission: permission,
  title: 'Integrations',
  link: integrationsLink,
  screen: <Integrations />,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/7022193908636-Integrations',
});
